export function pickLocalizedName(language, name, nameArabic, nameHebrew) {
  if (language === "ar" && nameArabic) return nameArabic;
  if (language === "he" && nameHebrew) return nameHebrew;
  return name;
}

export function localizedProductName(language, product) {
  return pickLocalizedName(language, product?.name, product?.nameArabic, product?.nameHebrew);
}

export function localizedProductDescription(language, product) {
  return pickLocalizedName(language, product?.description, product?.descriptionArabic, product?.descriptionHebrew);
}

// Cart, wishlist and order lines carry productName/productNameArabic/productNameHebrew.
export function localizedItemProductName(language, item) {
  return pickLocalizedName(language, item?.productName, item?.productNameArabic, item?.productNameHebrew);
}
